// 米問屋の蔵出し（課金・一俵100円）：兵糧を買う。設定は CONFIG.kuradashi。
// 1日（JST）に買える数は天下の石高（全員共通。リリースから週ごとに上がる）。
// 買った兵糧は本体に入れ、使わなかった分は購入ごとに kuradashi.days 日で消える（stamina.ts。チャットチケットと同じ期限の決まり）。
import { CONFIG } from './config';
import type { Profile } from './profile';
import { staminaNow } from './stamina';

const JST = 9 * 3_600_000;
const DAY = 86_400_000;
const jstDayOf = (t: number) => new Date(t + JST).toISOString().slice(0, 10);

/** 天下の石高＝その日（JST）に1人が買える数。steps のうち今日までに来た日の数 */
export const kokudaka = (now: number) => {
  const today = jstDayOf(now);
  return CONFIG.kuradashi.steps.filter((d) => d <= today).length;
};

/** 購入の反映：本体に一俵を足し、今から days 日の期限の束を足す（前に買った分の期限は変えない） */
export function grantKuradashi(p: Profile, now: number) {
  const s = staminaNow(p.stamina, now, p).state;
  const n = CONFIG.kuradashi.hyoro;
  p.stamina = { ...s, value: s.value + n, boughtLots: [...(s.boughtLots ?? []), { n, until: now + CONFIG.kuradashi.days * DAY }] };
}

/** 返金・チャージバック：まだ使っていない分から一俵まで、新しい購入の束から引く（使った分は戻さない） */
export function revokeKuradashi(p: Profile, now: number) {
  const s = staminaNow(p.stamina, now, p).state;
  let take = CONFIG.kuradashi.hyoro;
  let taken = 0;
  const lots = (s.boughtLots ?? []).map((l) => ({ ...l }));
  for (let i = lots.length - 1; i >= 0 && take > 0; i--) {
    const k = Math.min(lots[i].n, take);
    lots[i].n -= k;
    take -= k;
    taken += k;
  }
  const left = lots.filter((l) => l.n > 0);
  const { boughtLots: _l, ...rest } = s;
  p.stamina = { ...rest, value: Math.max(0, s.value - taken), ...(left.length ? { boughtLots: left } : {}) };
}
